<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AuctionDownload" });
import * as API from "../../services/api.js";
export let auctionKey;
export let format = "public";
</script>

{#if auctionKey !== undefined}

    {#await API.downloadAuction({ auctionKey, format }) then data}

        {#if Array.isArray(data) && data.length > 0}

            <slot { data } />

        {:else}

            <slot name="empty">
                <!-- We're keeping this empty because anything here doesn't look good in Cybele -->
            </slot>

        {/if}

    {/await}

{/if}